
import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
	.st0{fill:none;stroke:#2D2D2D;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}
`;

const SelfieHumanUnderline = () => {
	return (
		<Svg
			xmlns='http://www.w3.org/2000/svg'
			x='0'
			y='0'
			enableBackground='new 0 0 36 36'
			version='1.1'
			viewBox='0 0 36 36'
			xmlSpace='preserve'
		>
			<path
				d='M9 19v-5c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v11c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-2'
				className='st0'
			></path>
			<path
				d='M7 18h4c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-4z'
				className='st0'
			></path>
			<path d='M7 19L7 15' className='st0'></path>
			<circle cx='20' cy='9' r='5' className='st0'></circle>
			<path
				d='M19 26h10a9 9 0 00-9-9c-1.05 0-2.06.18-3 .51'
				className='st0'
			></path>
			<path d='M9 32L28 32' className='st0'></path>
		</Svg>
	);
};

export default SelfieHumanUnderline;

